export interface AzmoonMaharatDetail_SignIn_Interface {
    id:number,
    codeBehfa:string,
    code:string,
    title:string,
    name:String,
    delDes:String,
    visible:boolean,
  }
  
  export function Empty_AzmoonMaharatDetail_SignIn_Interface():AzmoonMaharatDetail_SignIn_Interface{
    return{
      id:0,
      codeBehfa:'',
      code:'',
      title:'',
      name:'',
      delDes:'',
      visible:false,
    }
  }